var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.count || _vm.initCount)?_c('div',{class:[
    _vm.counterSelector,
    {
      'favorite-products-counter_hidden': _vm.initCount && _vm.count === 0,
    } ]},[_vm._v("\n  "+_vm._s(_vm.count ? _vm.count : _vm.initCount)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }